import {
    BlogRollWidgetData,
    IBlogRollAllArticleContentWidgetStyle,
} from "@pageBuilder/typings";
import { CssProperties } from "../../../models/css-property";
import { BlogRollBaseStylesRenderer } from "./blog-roll-styles-renderer";

export class BlogRollAllArticleContentStylesRenderer extends BlogRollBaseStylesRenderer {

    public override render(element: HTMLElement, style: IBlogRollAllArticleContentWidgetStyle): void {
        super.render(element, style);

        const postListProps = new CssProperties();
        postListProps.tryAdd("--padding", style.padding);
        postListProps.tryAdd("--heading2-color", style.heading2Color);
        postListProps.tryAdd("--heading3-color", style.heading3Color);
        postListProps.tryAdd("--heading4-color", style.heading4Color);
        postListProps.tryAdd("--heading2-size", style.heading2Size);
        postListProps.tryAdd("--heading3-size", style.heading3Size);
        postListProps.tryAdd("--heading4-size", style.heading4Size);
        postListProps.tryAdd("--heading-font-family", style.headingFont?.family);
        postListProps.tryAdd("--heading-font-weight", style.headingFont?.weight);
        postListProps.tryAdd("--subheading-font-family", style.subheadingFont?.family);
        postListProps.tryAdd("--subheading-color", style.subheadingFont?.color);
        postListProps.tryAdd("--subheading-size", style.subheadingFont?.size);
        postListProps.tryAdd("--subheading-font-weight", style.subheadingFont?.weight);
        postListProps.tryAdd("--normal-text-size", style.normalTextFont?.size);
        postListProps.tryAdd("--normal-text-color", style.normalTextFont?.color);
        postListProps.tryAdd("--normal-text-font-family", style.normalTextFont?.family);
        postListProps.tryAdd("--normal-text-font-weight", style.normalTextFont?.weight);
        postListProps.tryAdd("background-color", style.postListBackground);
        this.styleService.setStyle(element, `#${element.id} .post-list`, postListProps.data);
    }

    public override getStyleSelectors(element: HTMLElement): string[] {
        const selectors = super.getStyleSelectors(element);
        const classicSelectors = [`#${element.id} .post-list`];
        selectors.push(...classicSelectors);
        return selectors;
    }

    public partialUpdateWithDefaults(style: IBlogRollAllArticleContentWidgetStyle): void {
        style.titleColor = BlogRollWidgetData.defaultStyle.titleColor;
        style.authorColor = BlogRollWidgetData.defaultStyle.authorColor;
        style.publishDateColor = BlogRollWidgetData.defaultStyle.publishDateColor;
        style.postBackground = BlogRollWidgetData.defaultStyle.postBackground;

        style.padding = BlogRollWidgetData.defaultAllArticleContentStyle.padding;
        style.headingFont = BlogRollWidgetData.defaultAllArticleContentStyle.headingFont;
        style.subheadingFont = BlogRollWidgetData.defaultAllArticleContentStyle.subheadingFont;
        style.normalTextFont = BlogRollWidgetData.defaultAllArticleContentStyle.normalTextFont;

        delete style.heading2Color;
        delete style.heading3Color;
        delete style.heading4Color;
        delete style.heading2Size;
        delete style.heading3Size;
        delete style.heading4Size;
    }

}
